import { render, staticRenderFns } from "./SearchActions.vue?vue&type=template&id=fa2cc2c0&scoped=true&"
import script from "./SearchActions.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchActions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2cc2c0",
  null
  
)

export default component.exports